import { PropsWithChildren } from "react";
import { Fade } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ModalStyles, Container, ModalHeader, ModalTitle, IconButton } from "./Modal.styles";
import { ModalProps } from "./Modal.props";

export const Modal = ({
  children,
  title,
  open,
  onClose,
  variant,
  unmountOnExit
}: PropsWithChildren<ModalProps>) => {
  return (
    <ModalStyles open={open} onClose={onClose}>
      <Fade in={open} unmountOnExit={unmountOnExit}>
        <Container variant={variant}>
          <ModalHeader>
            <ModalTitle>{title}</ModalTitle>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          {children}
        </Container>
      </Fade>
    </ModalStyles>
  );
};
